import { Divider, Heading, List } from '@apollo/orbit';
import React from 'react';

import { FieldsListItem } from '../insightsListItem/FieldsListItem';

interface Props {
  fieldCoordinate: string;
  loading: boolean;
}

export function SelectedFieldsListItem({ fieldCoordinate, loading }: Props) {
  return (
    <div className="pt-2">
      <Heading variant="title" className="my-2 ml-4">
        Selected
      </Heading>
      <List isInteractive className="mb-4">
        <FieldsListItem
          isSelected
          hideStatsValue={true}
          loading={loading}
          name={fieldCoordinate}
        />
      </List>
      <Divider />
    </div>
  );
}
